export default "__VITE_ASSET__57501893__"